import { combineReducers } from 'redux';

import textField from './textFieldReducer';

const appReducer = combineReducers({
  textField
});

export default appReducer;
